<template>
  <chart ref="monthchart" :options="chartOptions" />
</template>
<script>
import { Chart } from 'highcharts-vue'
import { minBy } from 'lodash'

export default {
  components: {
    Chart,
  },
  props: ['monthChart'],
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'line',
        },
        title: {
          text: null,
        },
        plotOptions: {
          series: {
            marker: {
              radius: 0,
              states: {
                hover: {
                  radiusPlus: 4,
                },
              },
            },
          },
        },
        tooltip: {
          shared: true,
          crosshairs: true,
          valueDecimals: 2,
          valueSuffix: ' m3',
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: {
          title: {
            text: 'Namerané hodnoty (m3)',
          },
        },
        series: [
          {
            name: 'Hranica 100%',
            color: '#000',
            lineWidth: 3,
            marker: {
              symbol: 'square',
            },
            data: [],
          },
          /*{
            name: 'Tolerancia 100% - 105%',
            color: '#3c6c9d',
            data: []
          },
          {
            name: 'Nadlimit 105% - 110%',
            color: '#eeb04d',
            data: []
          },
          {
            name: 'Nadlimit nad 110%',
            color: '#cc423f',
            data: []
          },*/
          {
            name: 'Odber',
            color: '#6fa55a',
            lineWidth: 2,
            data: [],
          },
        ],
        exporting: {
          buttons: {
            contextButton: {
              menuItems: ['downloadPNG', 'downloadPDF'],
            },
          },
          filename: 'intervalove-data_report',
        },
      },
    }
  },
  watch: {
    monthChart: {
      handler() {
        this.chartUpdate()
      },
      immediate: true,
    },
  },
  methods: {
    chartUpdate() {
      this.chartOptions.series[0].data = this.monthChart.border100
      /*this.$refs.monthchart.options.series[1].data = this.monthChart.tolerance100to105
      this.$refs.monthchart.options.series[2].data = this.monthChart.overLimit105to110
      this.$refs.monthchart.options.series[3].data = this.monthChart.overLimitOver110*/
      this.chartOptions.series[1].data = this.monthChart.values

      const series1 = this.chartOptions.series[1]
      const series2 = this.chartOptions.series[0]

      if (series2.data.length) {
        series1.zones = [
          { value: minBy(series2.data, 'y')?.y },
          { color: '#ff0000' },
        ]
      }
    },
  },
}
</script>
